import api from "./Api";

class ProdutoAdicionalService {
  GetProdutoAdicional(payload) {
    return api.get("/v1/produtoAdicional/" + payload).then((response) => {
      return response.data;
    });
  }

  PostProdutoAdicional(payload) {
    return api.post("/v1/produtoAdicional/", payload).then((response) => {
      return response.data;
    });
  }

  PutProdutoAdicional(payload) {
    return api.put("/v1/produtoAdicional/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteProdutoAdicional(payload) {
    return api.delete("/v1/produtoAdicional/" + payload).then((response) => {
      return response.data;
    });
  }

  GetProdutoAdicionalOData(payload) {
    return api.get("/OData/ProdutoAdicional" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ProdutoAdicionalService();
